<template>
  <l-control position="topleft">
    <div class="d-flex">
      <div
        @click="showCoorControl = !showCoorControl"
        style="border-radius: 5px; cursor: pointer;"
        class="d-flex justify-content-start align-items-start p-1"
      >
        <i class="fa-solid fa-compass" style="font-size: 28px;"></i>
      </div>

      <div
        v-if="showCoorControl"
        style="padding: 10px; border-radius: 10px; width: 220px;"
      >
        <div class="mb-1 font-weight-bold">Μετάβαση σε Συντεταγμένες</div>

        <div class="d-flex">
          <b-form-group
            label="Latitude"
            label-for="lat-input"
            class="mb-1"
          >
            <b-form-input
              id="lat-input"
              size="sm"
              v-model="inputLat"
              placeholder="π.χ. 37.99"
              type="number"
              step="any"
            />
          </b-form-group>

          <b-form-group
            label="Longitude"
            label-for="lng-input"
            class="mb-2"
          >
            <b-form-input
              id="lng-input"
              size="sm"
              v-model="inputLng"
              placeholder="π.χ. 23.73"
              type="number"
              step="any"
            />
          </b-form-group>
        </div>

        <b-button
          block
          size="sm"
          variant="primary"
          @click="goToCoordinates"
        >
          Μετάβαση
        </b-button>
      </div>
    </div>
  </l-control>
</template>

<script>
export default {
  name: 'GoToCoordinatesControl',
  props: {
    mapObject: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showCoorControl: false,
      inputLat: '',
      inputLng: ''
    };
  },
  methods: {
    goToCoordinates() {
      const lat = parseFloat(this.inputLat);
      const lng = parseFloat(this.inputLng);

      if (isNaN(lat) || isNaN(lng)) {
        alert('Παρακαλώ εισάγετε έγκυρες συντεταγμένες.');
        return;
      }

      this.mapObject.flyTo([lat, lng], 18, {
        animate: true,
        duration: 2
      });
    }
  }
};
</script>
